import { TextField, withStyles } from '@material-ui/core';

const DefaultInput = withStyles({
  root: {
    fontSize: '1.3rem',
    '& label.Mui-focused': {
      color: '#00B5E2',
    },
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderColor: '#00B5E2',
      },
    },
  },
})(TextField);

export default DefaultInput;
